import { Box, Typography, Tabs, TabList, Tab, TabPanel, ListItemDecorator, tabClasses } from "@mui/joy";
import { Package, Wrench, Calculator } from "lucide-react";
import { useSearchParams } from "react-router-dom";

import Materials from "./Materials";
import Labor from "./Labor";
import Estimating from "./Estimating";

export default function EstimateContractTabs(props: any) {
    const { measurements, setIsNextStageEligible } = props;
    const [searchParams, setSearchParams] = useSearchParams();
    const activeTab = searchParams.get("taskTab") || "materials";

    return (
        <Box mt={2}>
            <Tabs
                value={activeTab}
                sx={{ width: "100%" }}
                onChange={(_, value) => {
                    setSearchParams((prev) => {
                        const params = new URLSearchParams(prev);
                        params.set("taskTab", value as string);
                        return params;
                    });
                }}
            >
                <TabList
                    sx={{
                        gap: 2,
                        width: "calc(100% + 48px)", // Assuming parent padding is 20px (p: 2.5)
                        mx: -3, // Pull to edges
                        px: 2.5, // Keep tabs aligned with content
                        borderColor: "divider",
                        [`&& .${tabClasses.root}`]: {
                            flex: "initial",
                            color: "text.secondary",
                            opacity: 0.7,
                            background: "transparent",
                            bgcolor: "transparent",
                            paddingLeft: 0.5,
                            paddingRight: 0.5,
                            paddingBottom: 1.5,
                            paddingTop: 1.5,
                            fontWeight: 600,
                            "&:hover": {
                                bgcolor: "transparent",
                            },
                            [`&.${tabClasses.selected}`]: {
                                color: "primary.plainColor",
                                fontWeight: 600,
                                opacity: 1,
                                "&::after": {
                                    height: 2,
                                    borderTopLeftRadius: 3,
                                    borderTopRightRadius: 3,
                                    bgcolor: "primary.500",
                                },
                            },
                        },
                    }}
                >
                    <Tab value="materials">
                        <ListItemDecorator>
                            <Package size={16} />
                        </ListItemDecorator>
                        Materials
                    </Tab>
                    <Tab value="labor">
                        <ListItemDecorator>
                            <Wrench size={16} />
                        </ListItemDecorator>
                        Labor
                    </Tab>
                    <Tab value="estimating">
                        <ListItemDecorator>
                            <Calculator size={16} />
                        </ListItemDecorator>
                        Estimating
                    </Tab>
                </TabList>

                <TabPanel value="materials" sx={{ px: 0, pt: 2 }}>
                    <Materials measurements={measurements} setIsNextStageEligible={setIsNextStageEligible} />
                </TabPanel>

                <TabPanel value="labor" sx={{ px: 0, pt: 2 }}>
                    <Labor measurements={measurements} />
                </TabPanel>

                <TabPanel value="estimating" sx={{ px: 0, pt: 2 }}>
                    <Estimating measurements={measurements} />
                </TabPanel>
            </Tabs>
        </Box>
    );
}
